<div class="panel" style="height: 100%; display: flex; flex-direction: column">
  <mat-tab-group [preserveContent]="true" style="flex: 1; display: flex; flex-direction: column; overflow: hidden">
    <!-- Tab 1: Customer Information -->
    <mat-tab label="Customer Information">
      <div
        [formGroup]="form"
        class="editor-tab-body" style="height: 100%; display: flex; flex-direction: column; overflow-y: auto"
      >
        <div class="container">
          <div class="row">
            <div class="col-8">
              <div class="container">
                <div class="row">
                  <div class="col-6">
                    <div class="form-control">
                      <mat-form-field appearance="outline">
                        <mat-label>Customer Name</mat-label>
                        <input matInput formControlName="companyName" (blur)="onCompanyNameBlur()" />
                        <mat-error *ngIf="form.controls.companyName.hasError('required')">
                          {{ errorMessages.companyName.required }}
                        </mat-error>
                        <mat-error *ngIf="form.controls.companyName.hasError('minlength')">
                          {{ errorMessages.companyName.minlength }}
                        </mat-error>
                        <mat-error *ngIf="form.controls.companyName.hasError('maxlength')">
                          {{ errorMessages.companyName.maxlength }}
                        </mat-error>
                      </mat-form-field>
                    </div>
                  </div>
                  <div class="col-6">
                    <div class="form-control">
                      <mat-form-field appearance="outline">
                        <mat-label>Display Name</mat-label>
                        <input matInput formControlName="displayName" />
                        <mat-error *ngIf="form.controls.displayName.hasError('required')">
                          {{ errorMessages.displayName.required }}
                        </mat-error>
                      </mat-form-field>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-6">
                    <div class="form-control">
                      <mat-form-field appearance="outline">
                        <mat-label>First Name</mat-label>
                        <input matInput formControlName="contactFirstName" />
                        <mat-error *ngIf="form.controls.contactFirstName.hasError('required')">
                          {{ errorMessages.contactFirstName.required }}
                        </mat-error>
                        <mat-error *ngIf="form.controls.contactFirstName.hasError('minlength')">
                          {{ errorMessages.contactFirstName.minlength }}
                        </mat-error>
                        <mat-error *ngIf="form.controls.contactFirstName.hasError('maxlength')">
                          {{ errorMessages.contactFirstName.maxlength }}
                        </mat-error>
                        <mat-error *ngIf="form.controls.contactFirstName.hasError('pattern')">
                          {{ errorMessages.contactFirstName.pattern }}
                        </mat-error>
                      </mat-form-field>
                    </div>
                  </div>
                  <div class="col-6">
                    <div class="form-control">
                      <mat-form-field appearance="outline">
                        <mat-label>Last Name</mat-label>
                        <input matInput formControlName="contactLastName" />
                        <mat-error *ngIf="form.controls.contactLastName.hasError('required')">
                          {{ errorMessages.contactLastName.required }}
                        </mat-error>
                        <mat-error *ngIf="form.controls.contactLastName.hasError('minlength')">
                          {{ errorMessages.contactLastName.minlength }}
                        </mat-error>
                        <mat-error *ngIf="form.controls.contactLastName.hasError('maxlength')">
                          {{ errorMessages.contactLastName.maxlength }}
                        </mat-error>
                        <mat-error *ngIf="form.controls.contactLastName.hasError('pattern')">
                          {{ errorMessages.contactLastName.pattern }}
                        </mat-error>
                      </mat-form-field>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-6">
                    <div class="form-control-group form-control-group-compact">
                      <div class="form-control grow-2">
                        <mat-form-field appearance="outline">
                          <mat-label>Business Phone</mat-label>
                          <input
                            matInput
                            formControlName="businessPhone"
                            mask="(000) 000-0000"
                            [showMaskTyped]="true"
                            [dropSpecialCharacters]="false"
                          />
                          <mat-error *ngIf="form.controls.businessPhone.hasError('pattern')">
                            {{ errorMessages.businessPhone.pattern }}
                          </mat-error>
                        </mat-form-field>
                      </div>
                      <div class="form-control grow-0 shrink-2">
                        <mat-form-field appearance="outline">
                          <mat-label>Extension</mat-label>
                          <input matInput [formControl]="form.controls.businessPhoneExt" />
                          <mat-error *ngIf="form.controls.businessPhoneExt.hasError('pattern')">
                            {{ errorMessages.businessPhoneExt.pattern }}
                          </mat-error>
                        </mat-form-field>
                      </div>
                    </div>
                  </div>
                  <div class="col-6">
                    <div class="form-control form-control-no-margin">
                      <mat-form-field appearance="outline">
                        <mat-label>Mobile Phone</mat-label>
                        <input
                          matInput
                          formControlName="mobilePhoneNumber"
                          mask="(000) 000-0000"
                          [showMaskTyped]="true"
                          [dropSpecialCharacters]="false"
                        />
                        <mat-error *ngIf="form.controls.mobilePhoneNumber.hasError('pattern')">
                          {{ errorMessages.mobilePhoneNumber.pattern }}
                        </mat-error>
                      </mat-form-field>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-12">
                    <div class="form-control">
                      <div class="email-input-row">
                        <mat-form-field appearance="outline" class="email-input-field">
                          <mat-label>Email Address</mat-label>
                          <input
                            matInput
                            type="email"
                            #emailInput
                            placeholder="Enter email address"
                            (keyup.enter)="$event.preventDefault(); addEmail(emailInput)"
                          />
                        </mat-form-field>
                        <button
                          mat-raised-button
                          color="primary"
                          type="button"
                          class="add-email-btn"
                          (click)="addEmail(emailInput)"
                        >
                          <mat-icon>add</mat-icon>
                          Add
                        </button>
                      </div>
                      <div class="email-error" *ngIf="emailError">{{ emailError }}</div>
                      <div class="email-chip-list" *ngIf="contactEmails.length > 0">
                        <mat-chip-row *ngFor="let email of contactEmails; let i = index" (removed)="removeEmail(i)">
                          {{ email }}
                          <button matChipRemove type="button" aria-label="Remove email">
                            <mat-icon>cancel</mat-icon>
                          </button>
                        </mat-chip-row>
                      </div>
                    </div>
                  </div>
                </div>

                <!-- Customer Address Section -->
                <div class="row">
                  <div class="col-12">
                    <h4 style="margin-top: 16px; margin-bottom: 8px; color: #666">Customer Address</h4>
                  </div>
                </div>
                <div class="row">
                  <div class="col-12">
                    <div class="form-control">
                      <mat-form-field appearance="outline">
                        <mat-label>Street Address</mat-label>
                        <input matInput formControlName="customerAddress" />
                        <mat-error *ngIf="form.controls.customerAddress.hasError('maxlength')">
                          {{ errorMessages.customerAddress.maxlength }}
                        </mat-error>
                      </mat-form-field>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-6">
                    <div class="form-control">
                      <mat-form-field appearance="outline">
                        <mat-label>City</mat-label>
                        <input matInput formControlName="customerCity" />
                        <mat-error *ngIf="form.controls.customerCity.hasError('maxlength')">
                          {{ errorMessages.customerCity.maxlength }}
                        </mat-error>
                      </mat-form-field>
                    </div>
                  </div>
                  <div class="col-3">
                    <div class="form-control">
                      <mat-form-field appearance="outline">
                        <mat-label>State</mat-label>
                        <mat-select formControlName="customerState">
                          <mat-option [value]="null">None</mat-option>
                          <mat-option *ngFor="let state of usStates" [value]="state.code">
                            {{ state.code }} - {{ state.name }}
                          </mat-option>
                        </mat-select>
                      </mat-form-field>
                    </div>
                  </div>
                  <div class="col-3">
                    <div class="form-control">
                      <mat-form-field appearance="outline">
                        <mat-label>ZIP Code</mat-label>
                        <input matInput formControlName="customerZip" />
                        <mat-error *ngIf="form.controls.customerZip.hasError('pattern')">
                          {{ errorMessages.customerZip.pattern }}
                        </mat-error>
                      </mat-form-field>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-12">
                    <div class="form-control">
                      <mat-form-field appearance="outline">
                        <mat-label>Parent Company</mat-label>
                        <mat-select formControlName="parentCustomerId">
                          <mat-option [value]="null">None</mat-option>
                          <mat-option
                            *ngFor="let customer of availableParentCompanies"
                            [value]="customer.id"
                            [disabled]="customer.id === customerId"
                          >
                            {{ customer.displayName }} ({{ customer.companyAccountNumber }})
                          </mat-option>
                        </mat-select>
                        <mat-hint>For linking restaurants under same ownership</mat-hint>
                      </mat-form-field>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-4" style="height: 100%">
              <div class="container" style="height: 100%; display: flex; flex-direction: column">
                <div class="row">
                  <div class="col-12">
                    <div class="form-control">
                      <mat-form-field appearance="outline">
                        <mat-label>Account Number</mat-label>
                        <input matInput formControlName="companyAccountNumber" />
                        <mat-error *ngIf="form.controls.companyAccountNumber.hasError('required')">
                          {{ errorMessages.companyAccountNumber.required }}
                        </mat-error>
                        <mat-error *ngIf="form.controls.companyAccountNumber.hasError('pattern')">
                          {{ errorMessages.companyAccountNumber.pattern }}
                        </mat-error>
                      </mat-form-field>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-12">
                    <div class="form-control">
                      <mat-form-field appearance="outline">
                        <mat-label>Salesperson ID</mat-label>
                        <input matInput formControlName="salesPersonId" />
                      </mat-form-field>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-12">
                    <div class="form-control">
                      <!--
                        A picker when the profile maintains a terms list, free
                        text otherwise. The list is offered even when Payment
                        Term Maintenance is off: the ERP imports populate it
                        either way, and the flag governs only who may edit it.
                        `paymentTermOptions` always includes the customer's own
                        term, so one that has since been switched off still shows
                        rather than silently clearing on the next save.
                      -->
                      @if (paymentTermOptions().length) {
                        <mat-form-field appearance="outline">
                          <mat-label>Payment Terms</mat-label>
                          <mat-select formControlName="paymentTerms">
                            <mat-option [value]="''">None</mat-option>
                            @for (term of paymentTermOptions(); track term.value) {
                              <mat-option [value]="term.value">
                                {{ term.description || term.value }}
                              </mat-option>
                            }
                          </mat-select>
                          <mat-hint>Set by the ERP import; an edit here is replaced on the next import.</mat-hint>
                        </mat-form-field>
                      } @else {
                        <mat-form-field appearance="outline">
                          <mat-label>Payment Terms</mat-label>
                          <input matInput formControlName="paymentTerms" maxlength="100" />
                        </mat-form-field>
                      }
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-12">
                    <div class="toggle-item">
                      <mat-slide-toggle formControlName="isTestCustomer">Test Customer</mat-slide-toggle>
                      <p class="toggle-description">
                        Mark this as a test account (e.g. a test customer defined in your ERP)
                      </p>
                    </div>
                  </div>
                </div>
                <div class="row" style="height: 100%">
                  <div class="col-12" style="height: 100%; display: flex; flex-direction: column">
                    <div class="form-control" style="flex: 1 1 auto; display: flex; flex-direction: column">
                      <mat-form-field
                        appearance="outline"
                        style="flex: 1 1 auto; display: flex; flex-direction: column"
                      >
                        <mat-label>Notes</mat-label>
                        <textarea
                          matInput
                          [formControl]="form.controls.notes"
                          style="flex: 1 1 auto; resize: vertical; min-height: 100px"
                        ></textarea>
                        <mat-error *ngIf="form.controls.notes.hasError('maxlength')"> </mat-error>
                      </mat-form-field>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </mat-tab>

    <!-- Tab 2: Customer Settings -->
    <mat-tab label="Customer Settings">
      <div class="editor-tab-body" style="height: 100%; overflow-y: auto">
        <app-customer-settings-form
          [customerSettings]="customerData?.customerSettings"
          [isEditMode]="true"
          [hasDefaultPaymentMethod]="hasDefaultPaymentMethod"
        >
        </app-customer-settings-form>
      </div>
    </mat-tab>

    <!-- Tab 3: ERP Fields — only for a customer an ERP import actually populated. Read-only:
         this map is rewritten wholesale by the next delivery, so an edit here would be a lie. -->
    @if (hasErpFields()) {
      <mat-tab label="ERP Fields">
        <div class="editor-tab-body" style="height: 100%; overflow-y: auto">
          <p class="erp-fields__hint">
            Reference values from the distributor's ERP, refreshed on every customer import. Which
            fields appear is set when the ERP import is configured, so it differs between systems.
          </p>
          <dl class="erp-fields">
            @for (field of erpFields(); track field.label) {
              <div class="erp-fields__row">
                <dt class="erp-fields__label">{{ field.label }}</dt>
                <dd class="erp-fields__value">{{ field.value }}</dd>
              </div>
            }
          </dl>
        </div>
      </mat-tab>
    }
  </mat-tab-group>

  <!-- Save and Cancel buttons at the bottom -->
  <div
    style="
      padding: 16px;
      display: flex;
      justify-content: flex-end;
      gap: 12px;
      border-top: 1px solid #e0e0e0;
      background: white;
    "
  >
    <button mat-button (click)="cancelEdit()" style="min-width: 120px">Cancel</button>
    <button mat-raised-button color="primary" (click)="saveCustomer()" style="min-width: 120px">Save</button>
  </div>
</div>
